import React from "react";
import PropTypes from "prop-types";

import Screen from "shared/payment/components/Screen";
import WindowShade from "shared/payment/components/WindowShade";
import Description from "./Description";
import IncognitoPackages from "../containers/IncognitoPackages";

import "./App.scss";

const App = ({
	type,
	isVisible,
	toggleModalVisibility,
}) => {
	function _toggleModalVisibility() {
		return toggleModalVisibility(!isVisible);
	}

	const content = (
		<Screen className="incognitopackages-container">
			<Description />
			<IncognitoPackages />
		</Screen>
	);

	if (type && type === "modal") {
		return (
			<WindowShade
				isVisible={isVisible}
				toggleVisible={_toggleModalVisibility}
			>
				{ content }
			</WindowShade>
		);
	} else {
		return content;
	}
};

App.propTypes = {
	type: PropTypes.string,
	isVisible: PropTypes.bool,
	toggleModalVisibility: PropTypes.func.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/apps/incognito_packages/components/App.jsx